__turbopack_context__.v({
  "className": "lato_1765f0b2-module__0Sw8ya__className",
  "variable": "lato_1765f0b2-module__0Sw8ya__variable",
});
